"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubNavMenu = exports.SubNavLink = exports.SubNavItem = exports.StyledText = exports.NavMetaIcons = exports.NavMenu = exports.NavLink = exports.NavItem = exports.Nav = exports.DonateButtonWrapperBottom = exports.DesktopNavLink = exports.ChevronWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Link = _interopRequireDefault(require("../../../Atoms/Link/Link"));
var _hideVisually = _interopRequireDefault(require("../../../../theme/shared/hideVisually"));
var _zIndex = _interopRequireDefault(require("../../../../theme/shared/zIndex"));
var _arrowRight = _interopRequireDefault(require("./arrow-right.png"));
var _Text = _interopRequireDefault(require("../../../Atoms/Text/Text"));
const transitionDuration = 0.2;
const NavLinkClass = (0, _styledComponents.default)(_Link.default).withConfig({
  displayName: "HeaderNav2025style__NavLinkClass",
  componentId: "sc-xflhtq-0"
})(["display:inline-block;border:0;padding:25px;line-height:1rem;height:auto;font-weight:700;width:100%;color:", ";transition:color ", "s ease;text-decoration:none;:hover,:focus,:focus-within{border:0;}@media ", "{:hover,:focus{color:", ";background-color:", ";font-weight:inherit;}:focus-within{background-color:", ";&:hover{background-color:", ";}}}> div{height:auto;transition:transform 0.35s cubic-bezier(0.41,1.64,0.41,0.8);", "}"], _ref => {
  let {
    theme
  } = _ref;
  return theme.color('black');
}, transitionDuration, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.allBreakpoints('M');
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.color('red');
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.color('grey_extra_light');
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.color('white');
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.color('grey_extra_light');
}, _ref7 => {
  let {
    isExpanded
  } = _ref7;
  return isExpanded && (0, _styledComponents.css)(["transform:rotate(-180deg);"]);
});

/**
 * Navigation menu
 */
const Nav = exports.Nav = _styledComponents.default.nav.withConfig({
  displayName: "HeaderNav2025style__Nav",
  componentId: "sc-xflhtq-1"
})(["display:", ";width:100%;position:absolute;top:75px;left:0;", ";background-color:", ";box-shadow:0px 20px 20px 5px rgba(0,0,0,0.25);@media ", "{width:50%;right:0;left:inherit;box-shadow:-20px 15px 20px 0px rgba(0,0,0,0.25);}@media ", "{", ";position:relative;top:0;display:block;margin:0;width:100%;height:100%;box-shadow:none;}@media ", "{margin:0 10px;}> h2{", ";}"], _ref8 => {
  let {
    isExpandable
  } = _ref8;
  return isExpandable ? 'block' : 'none';
}, (0, _zIndex.default)('higher'), _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.color('white');
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.allBreakpoints('M');
}, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.allBreakpoints('Nav');
}, (0, _zIndex.default)('medium'), _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.allBreakpoints('NavWide');
}, _hideVisually.default);

/**
 * Sub Navigation Menu (second level)
 */
const SubNavMenu = exports.SubNavMenu = _styledComponents.default.ul.withConfig({
  displayName: "HeaderNav2025style__SubNavMenu",
  componentId: "sc-xflhtq-2"
})(["visibility:", ";display:", ";padding:0;position:relative;list-style:none outside;left:0;top:0;flex-direction:column;justify-content:center;align-items:center;background-color:", ";overflow:hidden;border-top:1px solid ", ";@media ", "{display:flex;width:330px;height:auto;padding:0;position:absolute;top:86px;left:-29px;border-radius:0 0 25px 25px;transition:opacity ", "s linear;opacity:0;box-shadow:0px 13px 15px 0 rgba(0,0,0,0.05);}"], _ref13 => {
  let {
    isSubMenuOpen
  } = _ref13;
  return isSubMenuOpen ? 'visible' : 'hidden';
}, _ref14 => {
  let {
    isSubMenuOpen
  } = _ref14;
  return isSubMenuOpen ? 'flex' : 'none';
}, _ref15 => {
  let {
    theme
  } = _ref15;
  return theme.color('white');
}, _ref16 => {
  let {
    theme
  } = _ref16;
  return theme.color('grey_medium');
}, _ref17 => {
  let {
    theme
  } = _ref17;
  return theme.allBreakpoints('Nav');
}, transitionDuration);

/**
 * Sub Menu list items
 */
const SubNavItem = exports.SubNavItem = _styledComponents.default.li.withConfig({
  displayName: "HeaderNav2025style__SubNavItem",
  componentId: "sc-xflhtq-3"
})(["padding:0;height:100%;width:100%;border-top:1px solid ", ";position:relative;transition:background-color ", "s ease;&:first-of-type{border-top:none;}span{font-weight:100;}"], _ref18 => {
  let {
    theme
  } = _ref18;
  return theme.color('grey_medium');
}, transitionDuration);

/**
 * Sub menu link item
 */
const SubNavLink = exports.SubNavLink = (0, _styledComponents.default)(NavLinkClass).withConfig({
  displayName: "HeaderNav2025style__SubNavLink",
  componentId: "sc-xflhtq-4"
})(["padding:20px 25px 22px 42px;color:", ";height:auto;position:relative;@media ", "{padding:20px 30px 22px;}"], _ref19 => {
  let {
    theme
  } = _ref19;
  return theme.color('black');
}, _ref20 => {
  let {
    theme
  } = _ref20;
  return theme.allBreakpoints('Nav');
});

/**
 * Navigation Menu (first level)
 */
const NavMenu = exports.NavMenu = _styledComponents.default.ul.withConfig({
  displayName: "HeaderNav2025style__NavMenu",
  componentId: "sc-xflhtq-5"
})(["background-color:", ";list-style:none outside;padding:0;margin:0;@media ", "{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-start;background-color:", ";}"], _ref21 => {
  let {
    theme
  } = _ref21;
  return theme.color('white');
}, _ref22 => {
  let {
    theme
  } = _ref22;
  return theme.allBreakpoints('Nav');
}, _ref23 => {
  let {
    theme
  } = _ref23;
  return theme.color('white');
});

/**
 * Menu item link
 */
const NavLink = exports.NavLink = (0, _styledComponents.default)(NavLinkClass).withConfig({
  displayName: "HeaderNav2025style__NavLink",
  componentId: "sc-xflhtq-6"
})(["display:flex;gap:4px;font-family:", ";", " @media ", "{padding:10px 0px 10px 0;height:auto;", " :hover,:focus-within,:focus{+ ", "{display:flex;opacity:1;}}}@media ", "{", "}"], _ref24 => {
  let {
    theme
  } = _ref24;
  return theme.fontFamilies(theme.font.regular);
}, _ref25 => {
  let {
    isExpanded,
    theme
  } = _ref25;
  return isExpanded && (0, _styledComponents.css)(["&,&:hover,&:focus-within,&:focus{color:", ";}"], theme.color('red'));
}, _ref26 => {
  let {
    theme
  } = _ref26;
  return theme.allBreakpoints('Nav');
}, _ref27 => {
  let {
    hasSubMenu
  } = _ref27;
  return hasSubMenu && (0, _styledComponents.css)(["padding:10px 14px 10px 0;"]);
}, SubNavMenu, _ref28 => {
  let {
    theme
  } = _ref28;
  return theme.allBreakpoints('NavWide');
}, _ref29 => {
  let {
    hasSubMenu
  } = _ref29;
  return hasSubMenu && (0, _styledComponents.css)(["padding:10px 16px 10px 0;"]);
});
const DesktopNavLink = exports.DesktopNavLink = (0, _styledComponents.default)(NavLink).withConfig({
  displayName: "HeaderNav2025style__DesktopNavLink",
  componentId: "sc-xflhtq-7"
})(["&,&:hover,&:focus,&:focus-within{background-color:", ";}"], _ref30 => {
  let {
    theme
  } = _ref30;
  return theme.color('white');
});

/**
 * Menu list items
 */
const NavItem = exports.NavItem = _styledComponents.default.li.withConfig({
  displayName: "HeaderNav2025style__NavItem",
  componentId: "sc-xflhtq-8"
})(["", ";position:relative;font-weight:700;border-bottom:1px solid ", ";li{span{border-bottom:none;padding-bottom:0;}:hover,:focus,:focus-within{span{border-bottom:none;padding-bottom:0;}}}span > a > div{transition:transform 0.35s cubic-bezier(0.41,1.64,0.41,0.8);}:hover,:focus,:focus-within{li{span{border-bottom:none;padding-bottom:0;}}span > a{color:", ";> div{transform:rotate(-180deg);img{filter:invert(0.5) sepia(1) saturate(100) hue-rotate(20deg);}}}}@media ", "{margin:0 22px 0 0;padding:25px 0px;border-bottom:none;:hover,:focus,:focus-within{> ", ",:focus-within > ", "{visibility:visible;opacity:1;display:flex;}}:hover,:focus,:focus-within{background-color:transparent;", ";span{border-bottom:2px solid ", ";padding-bottom:2px;}", "{display:flex;opacity:1;visibility:visible;flex-direction:column;}}}@media ", "{margin:0 20px 0 0;}"], (0, _zIndex.default)('medium'), _ref31 => {
  let {
    theme
  } = _ref31;
  return theme.color('grey_medium');
}, _ref32 => {
  let {
    theme
  } = _ref32;
  return theme.color('red');
}, _ref33 => {
  let {
    theme
  } = _ref33;
  return theme.allBreakpoints('Nav');
}, SubNavMenu, SubNavMenu, (0, _zIndex.default)('high'), _ref34 => {
  let {
    theme
  } = _ref34;
  return theme.color('black');
}, SubNavMenu, _ref35 => {
  let {
    theme
  } = _ref35;
  return theme.allBreakpoints('NavWide');
});
const ChevronWrapper = exports.ChevronWrapper = _styledComponents.default.div.withConfig({
  displayName: "HeaderNav2025style__ChevronWrapper",
  componentId: "sc-xflhtq-9"
})(["width:16px;position:absolute;top:20px;right:22px;height:16px;img{width:100%;display:block;height:auto;}@media ", "{position:absolute;top:10px;right:0;width:10px;}"], _ref36 => {
  let {
    theme
  } = _ref36;
  return theme.allBreakpoints('Nav');
});

// This represents the 'non-desktop'/mobile nav icons:
const NavMetaIcons = exports.NavMetaIcons = _styledComponents.default.div.withConfig({
  displayName: "HeaderNav2025style__NavMetaIcons",
  componentId: "sc-xflhtq-10"
})(["width:auto;display:flex;align-items:center;flex-direction:column;background-color:inherit;> div{height:60px;width:100%;display:flex;border-bottom:1px solid ", ";> a{height:inherit;width:100%;padding:15px 20px;position:relative;&:after{position:absolute;right:20px;top:50%;transform:translateY(-50%);content:\"\";width:20px;height:20px;background-image:url(", ");background-size:100%;background-repeat:no-repeat;}img{padding:5px;height:35px;width:35px;}span{transition:color 0.15s ease-out;}@media ", "{&:focus,&:hover{span{color:", ";}}}}&:first-child{margin-top:20px;}}@media ", "{display:none;}"], _ref37 => {
  let {
    theme
  } = _ref37;
  return theme.color('grey_medium');
}, _arrowRight.default, _ref38 => {
  let {
    theme
  } = _ref38;
  return theme.allBreakpoints('M');
}, _ref39 => {
  let {
    theme
  } = _ref39;
  return theme.color('red');
}, _ref40 => {
  let {
    theme
  } = _ref40;
  return theme.allBreakpoints('Nav');
});
const StyledText = exports.StyledText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "HeaderNav2025style__StyledText",
  componentId: "sc-xflhtq-11"
})(["@media ", "{font-size:15px;}@media ", "{font-size:1rem;}"], _ref41 => {
  let {
    theme
  } = _ref41;
  return theme.allBreakpoints('Nav');
}, _ref42 => {
  let {
    theme
  } = _ref42;
  return theme.allBreakpoints('NavWide');
});
const DonateButtonWrapperBottom = exports.DonateButtonWrapperBottom = _styledComponents.default.div.withConfig({
  displayName: "HeaderNav2025style__DonateButtonWrapperBottom",
  componentId: "sc-xflhtq-12"
})(["display:flex;justify-content:center;padding:35px 20px;background-color:inherit;a{width:calc(100% - 10px);transition:width 0.35s cubic-bezier(0.5,1.5,0.5,0.9);&:hover,&:focus{width:100%;box-shadow:rgba(0,0,0,0.1) 0 0 20px 0;}}@media ", "{display:none;}"], _ref43 => {
  let {
    theme
  } = _ref43;
  return theme.allBreakpoints('Nav');
});